import React from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { payRateModStyles } from '../../PayRate/PayRateMod.styles';
import { BillOvertime } from './BillOvertime';
import { BillDoubleTime } from './BillDoubleTime';
import { BillHolidayTime } from './BillHolidayTime';
import { BillOrientation } from './BillOrientation';
import { BillCallBack } from './BillCallBack';
import { PreceptorSection } from './PreceptorSection';
import { PricingAndFees } from '../PricingFees/PricingAndFees';
import { MealBreak } from '../MealBreak/MealBreak';
import { BillRateGwwMod } from '../BillRateGww/BillRateGww';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';

export const HourlyRates = ({ isExpanded }: { isExpanded: boolean }) => {
  const { t } = useTranslation();
  const { classes } = payRateModStyles({ isExpanded });
  const isModEdit = useSelector(selectIsEditMod);

  return (
    <Grid style={{ marginTop: '24px' }}>
      <Grid className={classes.divider}>
        <Divider />
      </Grid>
      <div style={{ marginTop: '24px' }}>
        <Typography component="span" className={classes.headings}>{`${t(
          'placement.placementMods.hourlyRates',
        )}`}</Typography>
      </div>
      <Grid>
        <Grid item container direction="row" xs={12} spacing={6}>
          <BillOvertime classes={classes} isModEdit={isModEdit} />
          <BillDoubleTime classes={classes} isModEdit={isModEdit} />
        </Grid>
        <Grid item container direction="row" xs={12} spacing={6}>
          <BillHolidayTime classes={classes} isModEdit={isModEdit} />
          <BillCallBack classes={classes} isModEdit={isModEdit} />
        </Grid>
        <Grid item container direction="row" xs={12} spacing={6}>
          <BillOrientation classes={classes} isModEdit={isModEdit} />
          <PreceptorSection classes={classes} isModEdit={isModEdit} />
        </Grid>
        <PricingAndFees classes={classes} isModEdit={isModEdit} />
        <BillRateGwwMod isExpanded={isExpanded} isModEdit={isModEdit} />
      </Grid>
    </Grid>
  );
};
